<template>
    <div class="materi-page">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-12 mb-5 mb-xl-0">
                    <router-view></router-view>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    export default {
        components: {
        },
        data() {
            return {
                modulId: this.$route.params.modulId,
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser'
            })
        },
        methods: {
			
        },
        created() {
            
        }
    }
</script>
<style>
.task-name {
    padding-right: 0 !important;
}
</style>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
</style>